import { connect } from 'react-redux';

import Banner from 'components/Banner';
import { CAMPAIGN_NAMES } from 'constants/personalizations';
import * as actions from 'state/actions';
import PersonalizationsSelector from 'state/selectors/personalizations';
import Settings from 'utils/Settings';

const mapStateToProps = (state, props) => {
  const { items, backgroundColor } = props;

  const globalExperimentPageSections = Settings.globalExperimentPageSections;
  const targetedBanners =
    globalExperimentPageSections?.filter(
      section => section.content._contentType === 'globalBanner'
    ) || [];

  const campaignNames = [
    CAMPAIGN_NAMES.MULTI_TOUCH_RETURNS_MESSAGING,
    CAMPAIGN_NAMES.MULTI_TOUCH_CAMPAIGN,
  ];

  const getCampaignData = campaignName =>
    PersonalizationsSelector.getTargetedPageSectionCampaignData(
      state,
      campaignName,
      targetedBanners
    );

  const campaignsData = campaignNames.map(getCampaignData);

  const isLoading = campaignsData.some(data => data?.isLoading);
  const activeCampaignData = campaignsData.find(data => data?.activePageSections?.length > 0) || {};

  const activeItems = activeCampaignData.activePageSections || items;
  const isSingleMessage = activeItems.length === 1;

  return {
    items: activeItems,
    isLoading,
    campaignAnalyticsMetadata: activeCampaignData.analyticsMetadata || {},
    backgroundColor,
    isSingleMessage,
  };
};

const mapDispatchToProps = dispatch => ({
  trackClick: (payload, campaignAnalyticsMetadata) => {
    const { dyDecisionId, dyVariationId } = campaignAnalyticsMetadata || {};

    dispatch(
      actions.trackGlobalBannerClick({
        message: payload,
      })
    );

    dispatch(
      actions.trackEngagementClick({
        eventCategory: 'Global',
        eventAction: `clickBanner - ${payload}`,
        eventLabel: 'BannerCTA',
        dyDecisionId,
        dyVariationId,
      })
    );

    // Because this function will be attached to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
